import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'addUserBulk',
    serviceName: 'unitadmin',
    query: gql`
      mutation addUserBulk(
        $file: Upload
        $cellphones: [String]
        $user_category_id: String
        $need_activation: Int
        $send_sms: [String]
      ) {
        addUserBulk(
          file: $file
          cellphones: $cellphones
          user_category_id: $user_category_id
          need_activation: $need_activation
          send_sms: $send_sms
        ) {
          user {
            id
            firstname
            lastname
            cellphone
          }
          messages
        }
      }
    `,
  },
};

export default schema;
